import {getCookie, setCookie} from './cookie';

// UTM Grabber
const nndcUtmParams = {
	'nndc_utm_campaign': 'utm_campaign',
	'nndc_utm_content': 'utm_content',
	'nndc_utm_medium': 'utm_medium',
	'nndc_utm_source': 'utm_source',
	'nndc_utm_term': 'utm_term',
	'nndc_gclid': 'gclid',
	'nndc_fbclid': 'fbclid',
};

const nndcQueryString = window.location.search;

if ( nndcQueryString.includes('utm') ) {
	setUtmCookies();
}

function setUtmCookies() {
	const urlParams = new URLSearchParams(nndcQueryString);

	Object.entries(nndcUtmParams).forEach(entry => {
		const [cname_utm_param, utm_param] = entry;
		let utm_value = urlParams.get( utm_param );
		utm_value = ( utm_value != null ) ? utm_value : '';

		setCookie( cname_utm_param, utm_value, 1, true );
	});
}

function fillUtmInLeadsForm() {
	const wa_form_class = '.whatsapp-form';

	// fill utm into whatsapp form
	Object.entries(nndcUtmParams).forEach(entry => {
		const [cname_utm_param, utm_param] = entry;

		document.querySelectorAll( wa_form_class + ' [name="' + utm_param + '"]' ).forEach(el => {
			el.value = getCookie( cname_utm_param );
		});
	});
}
fillUtmInLeadsForm();
// End of UTM Grabber



// WEBPACK FOOTER //
// ./scripts/global/main.js